import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-resolve.tsx
/**
* icon.24.resolve
*
* Keywords: checkmark, check, circle, complete, verified, approved, confirmation, success
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEyIDVhNyA3IDAgMSAxIDAgMTQuMDAxIDcgNyAwIDAgMSAwLTE0bTAgMWE2IDYgMCAxIDAgMCAxMiA2IDYgMCAwIDAgMC0xMm0yLjU3IDIuNzQ5YS41LjUgMCAxIDEgLjg2My41MDNsLTMuNSA2YS41LjUgMCAwIDEtLjgxNS4wNjlsLTIuNS0zYS41LjUgMCAwIDEgLjc2Ny0uNjRsMi4wNDMgMi40NTF6Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-1191
*/
const Icon24Resolve = memo(function Icon24Resolve(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M12 5a7 7 0 1 1 0 14.001 7 7 0 0 1 0-14m0 1a6 6 0 1 0 0 12 6 6 0 0 0 0-12m2.57 2.749a.5.5 0 1 1 .863.503l-3.5 6a.5.5 0 0 1-.815.069l-2.5-3a.5.5 0 0 1 .767-.64l2.043 2.451z"
		})
	});
});
//#endregion
export { Icon24Resolve };

//# sourceMappingURL=icon-24-resolve.js.map